import type { FieldInfoProps } from '../types';

function FieldInfo({ label, htmlFor, actionElement: actionElement, disabled }: FieldInfoProps) {
  const classes = {
    wrapper:
      'flex justify-between mb-2 paragraph-explanatory text-foreground data-[disabled=true]:pointer-events-none data-[disabled=true]:cursor-not-allowed data-[disabled=true]:opacity-50',
    action: 'underline cursor-pointer link-label-s',
  };

  if (!label && !actionElement) return null;

  return (
    <div className={classes.wrapper} data-disabled={disabled}>
      <label htmlFor={htmlFor} aria-hidden={!label}>
        {label}
      </label>
      {actionElement && <span className={classes.action}>{actionElement}</span>}
    </div>
  );
}

export { FieldInfo };
